<template>
  <div
    class="usp-poster-string"
    v-if="oneString"
    :class="{ 'font-responsive-small': small }"
  >
    <span>{{ ShippingMethodHeader }}.</span>&nbsp;
    <span>{{ ReturnTitle }}.</span>&nbsp;
    <span>{{ insertString("Global", "UspWarranty") }}.</span>&nbsp;
  </div>
  <div class="usp-poster" v-else>
    <ul
      class="checklist"
      :class="{
        '-current-color': currentColor,
        '-inverted': inverted,
        '-green': green,
        '-small': small,
        '-inline': inline,
      }"
    >
      <li v-html="ShippingMethodHeader" />
      <li v-html="ReturnTitle" />
      <li>{{ insertString("Global", "UspWarranty") }}</li>
    </ul>
  </div>
</template>

<script>

import siteInfo from '@/Scripts/lib/helper/siteInfo.js';

export default {
  mixins: [siteInfo],
  props: {
    inverted: {
      type: Boolean,
      default: false
    },
    green: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    oneString: {
      type: Boolean,
      default: false
    },
    currentColor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    };
  },
  computed: {
    ShippingMethodHeader () {
      if (
        this.usp &&
        this.usp.ShippingUsp
      ) {
        return this.usp.ShippingUsp;
      }
      return '';
    },
    ReturnTitle () {
      if (
        this.usp &&
        this.usp.ReturnUsp
      ) {
        return this.usp.ReturnUsp;
      }
      return this.insertString('Global', 'UspReturn');
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

.usp-poster {
  &-string {
    display: flex;
    flex-wrap: wrap;

    span {
      margin-right: 6px;
      white-space: nowrap;
    }
  }

  ul {
    margin: 0;

    &.-current-color {
      color: currentColor;

      &.checklist li::before {
        border-color: currentColor;
      }
    }
  }
  li {
    @include font-responsive(body, regular, small-caps);
    padding: 0;
  }
  .-small {
    li {
      @include font-responsive(small, regular);
      text-transform: none;
    }
  }
  .-inline {
    display: flex;
    li {
      margin-right: 18px;

      &:last-of-type {
        margin-right: 0;
        flex-shrink: 1;
      }
    }
  }
}
</style>
